export default function delNonNumCode (str: string) {
  if (!str) {
    return ''
  }
  const reg = /\D/g
  return str.replace(reg, '')
}
